import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import routePaths from 'routePaths';
import { colorPrimaryBlue } from 'utils/constants';
import msalBG from 'assets/images/msalLoginBG.jpeg';
import nurtureLogo from 'assets/images/sustain-logo.svg';
import { useAppDispatch } from 'store/hooks';
import { redirect } from 'actions/navigation';
import { useMsalAuth } from 'customHooks/useMsalAuth';

const containerStyles = {
	backgroundImage: `url(${msalBG})`,
	backgroundPosition: 'center',
	backgroundRepeat: 'no-repeat',
	backgroundSize: 'cover',
	minHeight: '100vh',
	display: 'flex',
	justifyContent: 'center',
	alignItems: 'center',
};

const loginBoxStyles = {
	background: '#fff',
	boxShadow:
		'0 2px 1px -1px rgb(0 0 0 / 20%), 0 1px 1px 0 rgb(0 0 0 / 14%), 0 1px 3px 0 rgb(0 0 0 / 12%)',
	height: '340px',
	width: '380px',
	borderRadius: '4px',
	padding: '20px',
};

const LoginPage = (): JSX.Element => {
	const { loginMsal, isAuthenticated } = useMsalAuth();
	const history = useHistory();
	const dispatch = useAppDispatch();

	const login = async () => {
		await loginMsal();
	};

	useEffect(() => {
		if (isAuthenticated) {
			let currentPath = sessionStorage.getItem('currentWorkingRoute')
				? `/apps/${sessionStorage.getItem('currentWorkingRoute')}`
				: routePaths.mapView;
			dispatch(redirect(currentPath));
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [isAuthenticated]);

	return (
		<Box sx={containerStyles}>
			<Box sx={loginBoxStyles}>
				<Toolbar
					sx={{
						display: 'flex',
						alignItems: 'center',
					}}
				>
					<Box
						sx={{
							textAlign: 'center',
							width: '100%',
							cursor: 'pointer',
						}}
						onClick={() => {
							history.push(routePaths.mapView);
						}}
					>
						<img
							src={nurtureLogo}
							alt="Nurture Logo"
							height="36px"
						/>
					</Box>
				</Toolbar>
				<Box textAlign="center">
					<Typography>nurture.farm</Typography>
				</Box>
				<Box
					sx={{
						textAlign: 'center',
						color: colorPrimaryBlue,
						marginBottom: '20px',
					}}
				>
					<Typography>Partner</Typography>
				</Box>
				<Box sx={{ textAlign: 'center' }}>
					<Typography fontSize="1.5rem">Welcome to</Typography>
					<Typography fontSize="1.5rem">Maps Portal</Typography>
				</Box>
				<Button
					sx={{
						fontSize: '1rem',
						marginTop: '30px',
						height: '50px',
						':hover': {
							bgcolor: colorPrimaryBlue,
							color: 'white',
						},
					}}
					variant="outlined"
					onClick={login}
					fullWidth
				>
					Login
				</Button>
			</Box>
		</Box>
	);
};

export default LoginPage;
